module.exports = __webpack_public_path__ + "static/media/eop-440x260.db69cbbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/adverts/eop-440x260.jpg
// module id = 68
// module chunks = 0